var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagComment = function SvgFlagComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#95959A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.25 1.25v1.125m0 12.375v-4.5m0 0 2.078-.52a6.75 6.75 0 0 1 4.655.512l.081.04a6.75 6.75 0 0 0 4.565.533l2.336-.55a36.4 36.4 0 0 1-.004-7.873l-2.332.548a6.75 6.75 0 0 1-4.565-.533l-.08-.04a6.75 6.75 0 0 0-4.656-.511l-2.078.519m0 7.875V2.375"
  })));
};
export default SvgFlagComment;